export const matchesSearch = (person, searchValue) => {
    if (!searchValue.includes(" ")) {
        return strMatchesSearch(person, searchValue);
    }
    for (const str of searchValue.split(" ")) {
        console.log(str + " " + person.FirstName + " " + person.LastName);
        console.log(strMatchesSearch(person, str));
        if (!strMatchesSearch(person, str)) {
            return false;
        }
    }
    return true;
}

const strMatchesSearch = (person, str) => {
    return person.FirstName.toLowerCase().includes(str.toLowerCase()) ||
        person.LastName.toLowerCase().includes(str.toLowerCase())
}